import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const BlindSpotMonitorModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerBlindSpotMonitorModalModal}
    contentClassName={cx(
      styles.containerContent,
      styles.isFullWidth,
    )}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Alerts driver of vehicles in the adjecent lanes via a
      audible and/or visual warning.
    </div>
  </PlainModal>
);
